export const GET_SHOW_PAGE_REQUEST = 'GET_SHOW_PAGE_REQUEST';
export const GET_SHOW_PAGE_SUCCESS = 'GET_SHOW_PAGE_SUCCESS';
export const GET_SHOW_PAGE_ERROR = 'GET_SHOW_PAGE_ERROR';



// WEBPACK FOOTER //
// ./src/store/showPage/showPageActionTypes.js